import React from 'react'
import '../styles/theme.scss'

import {BrowserRouter, Switch} from 'react-router-dom'
import {Provider} from 'react-redux'
import PropTypes from 'prop-types'
import {renderRoutes} from 'react-router-config'

class App extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.array.isRequired,
  };

  shouldComponentUpdate() {
    return false
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <div className={'theme'} style={{height: '100%'}}>
          <BrowserRouter>
            {renderRoutes(this.props.routes)}
          </BrowserRouter>
        </div>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js